exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".pos-input input {\n  background: #eef3f7 !important;\n  border: 0px !important;\n  border-radius: 20px !important;\n  color: #4b8bb1 !important;\n  font-weight: 700 !important;\n  margin: 4px !important;\n  margin-left: 2px !important;\n  margin-right: 2px !important;\n  padding: 6px 22px !important;\n  border-bottom: none !important;\n  text-align: center !important;\n}\n.pos-input-margin {\n  margin-top: -40px;\n}\n.pos-input {\n  background: #eef3f7;\n  border: 0;\n  border-radius: 20px !important;\n  color: #122f5b !important;\n  font-weight: 700 !important;\n  margin: 4px;\n  margin-left: 2px;\n  margin-right: 2px;\n  border-bottom: none !important;\n  text-align: center;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/less-loader/dist/cjs.js!./src/pages/pointofsale/styles/components/input.less
// module id = 3115
// module chunks = 0